"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useLoading = (color, small) => {
    const theme = (0, material_1.useTheme)();
    const container = {
        '.loading': {
            textAlign: 'center',
            color: color === 'contained'
                ? theme.qlub.palette.white.main
                : color === 'containedLight' ||
                    color === 'text' ||
                    color === 'outlined' ||
                    color === 'textElevated' ||
                    color === 'grey'
                    ? theme.qlub.palette.iris.main
                    : theme.qlub.palette.destructive.main,
            '@keyframes kkEllipsis1': {
                '0%': {
                    transform: 'scale(0)',
                },
                '100%': {
                    transform: 'scale(1)',
                },
            },
            '@keyframes kkEllipsis2': {
                '0%': {
                    transform: 'translate(0, 0)',
                },
                '100%': {
                    transform: small ? 'translate(12px, 0)' : 'translate(24px, 0)',
                },
            },
            '@keyframes kkEllipsis3': {
                '0%': {
                    transform: 'scale(1)',
                },
                '100%': {
                    transform: 'scale(0)',
                },
            },
        },
        '.kkEllipsis': {
            display: 'inline-block',
            position: 'relative',
            width: small ? '50px' : '70px',
            height: '20px',
            '& div': {
                position: 'absolute',
                top: '10px',
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: color === 'contained'
                    ? theme.qlub.palette.white.main
                    : color === 'containedLight' ||
                        color === 'text' ||
                        color === 'outlined' ||
                        color === 'textElevated' ||
                        color === 'grey'
                        ? theme.qlub.palette.iris.main
                        : theme.qlub.palette.destructive.text,
                animationTimingFunction: 'cubic-bezier(0, 1, 1, 0)',
                '&:nth-of-type(1)': {
                    left: '8px',
                    animation: 'kkEllipsis1 0.6s infinite',
                },
                '&:nth-of-type(2)': {
                    left: '8px',
                    animation: 'kkEllipsis2 0.6s infinite',
                },
                '&:nth-of-type(3)': {
                    left: small ? '20px' : '32px',
                    animation: 'kkEllipsis2 0.6s infinite',
                },
                '&:nth-of-type(4)': {
                    left: small ? '32px' : '56px',
                    animation: 'kkEllipsis3 0.6s infinite',
                },
            },
        },
    };
    return {
        container,
    };
};
exports.default = useLoading;
